import React from "react";
import { Building2, Users, Gift, Hotel, Heart, Briefcase } from "lucide-react";

const SECTORS = [
  { icon: Hotel, title: "Hotels", line: "Δώρα καλωσορίσματος για 5-star ξενοδοχεία" },
  { icon: Building2, title: "Villas", line: "Luxury welcome packages για ιδιωτικές βίλες" },
  { icon: Users, title: "Airbnb Hosts", line: "Premium αναμνηστικά για επιλεγμένους guests" },
  { icon: Briefcase, title: "Corporate", title_en: "Corporate", line: "Εταιρικά δώρα για VIP πελάτες & συνεργάτες" },
  { icon: Heart, title: "Weddings", line: "Wedding favors που μένουν αξέχαστα" },
  { icon: Gift, title: "Real Estate", line: "Closing gifts για premium ακίνητα" },
];

export const CorporateGifting = ({ onInquire }) => {
  return (
    <section
      id="corporate"
      data-testid="corporate-section"
      className="relative py-32 sm:py-48 px-6 overflow-hidden"
    >
      {/* Black marble texture background */}
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: "url('/marble-dark.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.35,
          mixBlendMode: "lighten",
        }}
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.35) 20%, rgba(0,0,0,0.35) 80%, rgba(0,0,0,0.75) 100%)",
        }}
      />
      <div className="relative z-10 max-w-6xl mx-auto">
        <div className="mb-24 text-center">
          <p className="font-display text-[10px] tracking-[0.55em] text-[color:var(--goldenelia-gold)] uppercase mb-6">
            For Discerning Hosts
          </p>
          <h2 className="font-serif-luxury text-4xl sm:text-5xl lg:text-6xl gold-gradient-text mb-8 leading-[1.1]">
            Bespoke Gifting <br />
            <em className="italic font-light text-[color:var(--goldenelia-cream)]/80">for the few who notice.</em>
          </h2>
          <div className="gold-divider max-w-xs mx-auto">
            <span className="diamond" />
          </div>
          <p className="font-serif-luxury italic text-lg text-[color:var(--goldenelia-cream)]/70 mt-8 max-w-2xl mx-auto leading-relaxed">
            Custom collections crafted for hotels, villas, weddings and corporate clients who refuse the ordinary.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {SECTORS.map((s) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-testid={`corporate-sector-${s.title.toLowerCase().replace(/\s/g, "-")}`}
                className="group relative bg-black/55 backdrop-blur-sm border border-[color:var(--goldenelia-gold)]/15 hover:border-[color:var(--goldenelia-gold)]/45 p-10 sm:p-12 hover:bg-black/70 transition-all duration-500"
              >
                <Icon
                  size={28}
                  strokeWidth={1.1}
                  className="text-[color:var(--goldenelia-gold)] mb-8 transition-transform duration-700 group-hover:scale-110"
                />
                <h3 className="font-serif-luxury text-2xl text-[color:var(--goldenelia-cream)] mb-3">
                  {s.title}
                </h3>
                <p className="font-body text-sm text-[color:var(--goldenelia-cream)]/55 leading-relaxed">
                  {s.line}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-20 text-center">
          <button
            data-testid="corporate-cta"
            onClick={onInquire}
            className="btn-ghost-gold !px-10 !py-4 text-[11px]"
          >
            Request a Bespoke Proposal
          </button>
          <p className="font-body text-xs text-[color:var(--goldenelia-cream)]/45 mt-6 tracking-wider">
            Minimum 10 boxes · Custom branding available · Worldwide delivery
          </p>
        </div>
      </div>
    </section>
  );
};

export default CorporateGifting;
